import { ITipoAgendamento } from "../../../../Interfaces/Geral/GestaoDeCadastro/TipoAgendamento/TipoAgendamentoInterface";
import Axios from "../../../Config/API";
import Service from "../../../Service";

export async function ListarTipoAgendamentoService() {
    return Service(Axios.get(`/home/tipoagendamento/listartipoagendamento`));
}

export async function CadastrarTipoAgendamentoService(
    requestBody: ITipoAgendamento
) {
    return Service(
        Axios.post(
            `/home/tipoagendamento/cadastrartipoagendamento`,
            requestBody
        )
    );
}

export async function AtualizarTipoAgendamentoService(
    requestBody: ITipoAgendamento
) {
    return Service(
        Axios.put(`/home/tipoagendamento/atualizartipoagendamento`, requestBody)
    );
}

export async function DeletarTipoAgendamentoService(idTipoAgendamento: number) {
    return Service(
        Axios.delete(
            `/home/tipoagendamento/deletartipoagendamento?idTipoAgendamento=${idTipoAgendamento}`
        )
    );
}
